export default {
      id: "logo_css-usage",
      viewBox: "0 0 127 80",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#logo_css-usage",
      toString: function () {
        return this.url;
      }
    }